import React from "react";

const Icon = ({ icon }) => <span className={`fas fa-${icon}`} />;

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon.js